import React, { useEffect } from 'react';
import Header from '../components/Header';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

const RSVPClosed: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div id="rsvp-closed">
      <div className="banner-wrapper">
        <Header currentPage="rsvp" />
        <Navigation />
      </div>
      <div className="page-content">
        <div className="page-heading" id="rsvp">RSVP</div>
        <div className="page-small-text" id="rsvp" style={{ textAlign: 'center', marginTop: '40px' }}>
          <p>
            We have reached our RSVP deadline! To ensure our seating and catering are accurate, guests whom we have not heard from have been marked as not attending. We'll miss you at the party, but appreciate your understanding as we finalize the details for our big day.
          </p>
          <br />
          <p>
            If something has changed and you are no longer able to attend, please reach out to Emily or Arian directly.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default RSVPClosed;
